/**
 * Ornaments (`rpg/ornements.ts#ornementDefinitions`), hand-ported: that
 * module initializes Firebase on import, so the data sync cannot load it.
 * Id = position (the bot's `importOrnements`). Left/right are emoji tokens
 * drawn around the player's name.
 */
export interface OrnamentDef {
  id: number;
  name: string;
  left: string;
  right: string;
}

const RAW: [string, string, string][] = [
  ['None', '', ''],
  ['4k', '<:4kleft:790245906929942561>', '<:4kright:790245936210509852>'],
  ['6k', '<:6kleft:790245945791086662>', '<:6kright:790245953293516830>'],
  ['8k', '<:8kleft:790245962315464734>', '<:8kright:790245970143084544>'],
  ['10k', '<:10kleft:790245980175466526>', '<:10kright:790245979952644147>'],
  ['12k', '<:12kleft:790246002584977418>', '<:12kright:790246002325979136>'],
  ['14k', '<:14kleft:790246032876765236>', '<:14kright:790246033078353950>'],
  ['16k', '<:16kleft:790246046562254918>', '<:16kright:790246046802509884>'],
  ['18k', '<:18kleft:790895058257051657>', '<:18kright:790895058235817985>'],
  ['20k', '<:20kleft:790886726260359168>', '<:20kright:790886725987205133>'],
  ['Brakmar', '<:brakleft:789712715685691432>', '<:brakright:789712616888205352>'],
  ['Bonta', '<:bontaleft:789711134391402536>', '<:bontaright:789711126073049108>'],
  ['Challenges', '<:challleft:790651340895944734>', '<:challright:790651340950470666>'],
  ['Sram', '<:sramleft:790246060236079165>', '<:sramright:790246060823412746>'],
  ['Xelor', '<:xelorleft:790246074178469908>', '<:xelorright:790246074207174706>'],
  ['Ecaflip', '<:ecaleft:790651372273664050>', '<:ecaright:790651372537249822>'],
  ['Enutrof', '<:enuleft:790651384851595285>', '<:enuright:790651385163153408>'],
  ['om475', '<:om475left:790651399985299456>', '<:om475right:790651399461535805>'],
  ['Baleine', '<:whaleleft:790651356842819584>', '<:whaleright:790651356544237618>'],
  ['Chafer crit', '<:chafer_crit:746385259930714203>', '<:r_chafer_crit:797197939910639616>'],
  ['Chafer', '<:chafer:746385107023036536>', '<:r_chafer:797198458997964830>'],
  ['Saint Valentin', '<:stv_l:805193261173178418>', '<:stv_r:805193261245136926>'],
  ['Battlepass Season 1 : Rainbow', '<:bpseason1_left:868226267869245522>', '<:bpseason1_right:868226268187992094>'],
  ['Battlepass Season 2 : Snowflake', '<:bpseason2_left:880521486740357170>', '<:bpseason2_right:880521487373725706>'],
  ['Battlepass Season 3 : Emerald', '<:bpseason3_left:880521487075921990>', '<:bpseason3_right:880521486681649182>'],
  ['Battlepass Season 4 : Phoenix', '<:bpseason4_left:880521486941687879>', '<:bpseason4_right:880521486698446888>'],
  ['Battlepass Season 5 : Frost', '<:bp5_left:880521486379659346>', '<:bp5_right:880521486652297288>'],
  ['Battlepass Season 6 : Amethyst', '<:bp6_left:880521487088517130>', '<:bp6_right:880521486706806785>'],
  ['Battlepass Season 7 : Ruby', '<:bp7_left:880521486736171048>', '<:bp7_right:880521486639722547>'],
  ['Battlepass Season 8 : Gold', '<:bp8_left:880521486346100736>', '<:bp8_right:880521487176564838>'],
  ['Battlepass Season 9 : Sapphire', '<:bp9_left:880521486744584212>', '<:bp9_right:880521486262210570>'],
  ['Battlepass Season 10 : Sunwell', '<:bp10_left:880521487277228143>', '<:bp10_right:880521487059157063>'],
  ['Battlepass Season 11 : Rosebud', '<:bp11_left:880521486488715374>', '<:bp11_right:880521485943463938>'],
  ['Battlepass Season 12 : Prestige', '<:bp12_left:880521487172399154>', '<:bp12_right:880521486769750036>'],
  ['Nitro', '<a:nitro_left:880521488158064672>', '<a:nitro_right:880521487407259668>'],
  ['Halloween', '<:halloween_left:898174735823798294>', '<:halloween_right:898174736415207454>'],
  ['VIP 4', '<:vip4_left:981561266889981992>', '<:vip4_right:981561266441158656>'],
  ['VIP 9', '<:vip9_left:981561266604761118>', '<:vip9_right:981561266621513728>'],
];

export const ornaments: OrnamentDef[] = RAW.map(([name, left, right], id) => ({ id, name, left, right }));
